import styled from 'styled-components';
import C from '@assets/themes/colors';


interface IStyleProps {
  width?: string;
  right?: boolean
}

export const Root = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const Row = styled.div`
  display: flex;
  width: calc(100% - 622px);
  height: 100%;
`

export const Rows = styled.div`
  width: 100%;
  height: calc(100% - 45px);
  display: flex;
`
export const Col = styled.div`
  display: flex;
  width: ${(props: IStyleProps) => (props.width ?? `calc(100% - 73px)`)};
  height: 100%;
  flex-direction: column;
`

export const SelectDescribeContainer = styled.div`
  position: absolute;
  right: 0px;
  z-index: 80;
  width: 194px;
  padding-top:6px;
  padding-right: 44px;
  height: 39px;
`

export const PickerContainer = styled.div`
  height: calc(100% - 109px);
  margin-top: 0.4px;
  position: absolute;
  ${(props: IStyleProps) => (props.right ? 'right: -17px;' : '')};  
  z-index: 5;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
`

export const CanvasContainer = styled.div`
  background-color: #282828;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`

export const SelectElementMessage = styled.div`
  width: ${(props: IStyleProps) => (props.width ? props.width : '380px')};
  padding: 15px 16px 15px 26px;
  border-radius: 5px;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  background-color: #FFFFFF;
  z-index: 10000;
  display: flex;
  flex-direction: row;
`

export const TextMessage = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: left;
  color: #122442;
`

export const CloseMessage = styled.div`
  cursor: pointer;
  flex-grow: 1;
  text-align: right;
`

export const PointerSelectElement = styled.div`
  margin: 8px 0px 0px 0px;
  z-index: 10001;
`

export const SelectElement = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 80px;
  left: 640px;
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  z-index: 10000;
`

export const SelectMultiple = styled.div`
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 120px;
  left: 346px;
  margin: 0px 0px 0px 0px;
  padding: 0px 0px 0px 0px;
  z-index: 10000;
`